import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { baseApi } from 'api/baseApi';
import { createEpicMiddleware } from 'redux-observable';
import { reducer as search } from 'search';
import auth from 'auth/store/auth/reducer';
import entities from 'store/entities/reducer';
import spaces from 'spaces/store/reducer';
import folders from 'documents/store/folders/reducer';
import tags from 'documents/store/tags/reducer';
import documents from 'documents/store/documents/reducer';
import { reducer as modal } from 'modal';
import ui from 'store/ui/reducer';
import users from 'auth/store/users/reducer';
import roles from 'auth/store/roles/reducer';
import { reducer as feeds } from 'feeds';
import { defaultDashboardsReducer as defaultDashboards, myDashboardReducer as myDashboard } from 'dashboard';
import permissions from 'auth/store/permissions/reducer';
import { reducer as contacts } from 'contacts';
import errors from 'base/errors/store/reducer';
import { defaultFavoritesReducer as defaultFavorites, favoritesReducer as favorites } from 'favorites';
import fileExplorer from 'documents/store/fileexplorer/reducer';
import { reducer as news } from 'news';
import audit from 'auth/store/audit/reducer';
import { reducer as trash } from 'trash';
import { reducer as offline } from 'offline';
import mailingLists from 'documents/store/mailinglists/reducer';
import globalPermissions from 'auth/store/globalPermissions/reducer';
import rootEpic from 'store/rootEpic';

const epicMiddleware = createEpicMiddleware();
export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    search,
    auth,
    entities,
    spaces,
    // @ts-ignore
    folders,
    tags,
    // @ts-ignore
    documents,
    modal,
    ui,
    // @ts-ignore
    users,
    // @ts-ignore
    roles,
    feeds,
    myDashboard,
    defaultDashboards,
    // @ts-ignore
    permissions,
    contacts,
    // @ts-ignore
    errors,
    favorites,
    defaultFavorites,
    fileExplorer,
    news,
    audit,
    trash,
    // @ts-ignore
    offline,
    mailingLists,
    globalPermissions,
  },
  // @ts-ignore
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false, // Disabled due to performance issues in development mode
    }).concat(baseApi.middleware, epicMiddleware),
});

// @ts-ignore
epicMiddleware.run(rootEpic);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
